import { createReducer, createSelector } from '@reduxjs/toolkit';
import set from 'lodash/fp/set';
import { updateBlockComponent } from './StoryReducer';
import type { StorytellerState } from 'store/StorytellerReduxState';
import {
  updateFilterParameterConfiguration,
  updateAllFilterParameterConfigurations,
  updateAllDraftFilterParameterConfigurations,
  updateDraftFilterParameterConfiguration,
} from 'store/TopLevelActions';
import { FeatureFlags } from '@socrata/platform/feature-flags';

export interface StoryChangesState {
  hasStoryChanged: boolean;
}

const initialState: StoryChangesState = {
  hasStoryChanged: false,
};

export const selectStoryChangesState = (state: StorytellerState) => state.storyChanges;

export const selectHasStoryChanged = createSelector(selectStoryChangesState, (it) => it.hasStoryChanged);

export const storyChangesReducer = createReducer(initialState, (builder) => {
  builder.addMatcher(
    (action) => {
      if (FeatureFlags.valueOrDefault('enable_batch_running_filters')) {
        return [
          updateAllDraftFilterParameterConfigurations.type,
          updateDraftFilterParameterConfiguration.type,
          updateBlockComponent.type,
        ].includes(action.type);
      } else {
        return [
          updateFilterParameterConfiguration.type,
          updateAllFilterParameterConfigurations.type,
          updateBlockComponent.type,
        ].includes(action.type);
      }
    },
    set('hasStoryChanged', true),
  );
});
